const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConvSentIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "prefix__done-24px",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_8831",
    d: "M0 0h15v15H0z",
    "data-name": "Path 8831",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_8832",
    d: "M7.038 12.447L4.86 10.236a.606.606 0 0 0-.871 0 .628.628 0 0 0 0 .884L6.6 13.767a.613.613 0 0 0 .877 0l6.594-6.69a.628.628 0 0 0 0-.884.605.605 0 0 0-.871 0z",
    "data-name": "Path 8832",
    transform: "translate(-1.402 -2.297)",
    style: {
      fill: "#0073b1"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConvSentIcon);
export default __webpack_public_path__ + "static/media/conv-sent-icon.5ed96292e1c5d281a97b3d6c00ad5757.svg";
export { ForwardRef as ReactComponent };